import {CommonOptionVM} from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"

export class GlobalItemOptionsVM extends CommonOptionVM {
  global_item_id?: string
  template_main_item_base_id?: string

  constructor(data: Partial<GlobalItemOptionsVM> = {}) {
    super(data)
    this.global_item_id = (data as any)?.global_item_id ?? undefined
    this.template_main_item_base_id = (data as any)?.template_main_item_base_id ?? undefined
  }

  validateData() {
    const errors: any[] = []
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default GlobalItemOptionsVM